import { render, staticRenderFns } from "./PatientHistoryViewDetailsAll.vue?vue&type=template&id=38b6bf86&scoped=true&lang=pug&"
import script from "./PatientHistoryViewDetailsAll.vue?vue&type=script&lang=js&"
export * from "./PatientHistoryViewDetailsAll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b6bf86",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
